import { toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { currentCompanySelector } from '../../../Store/paramsBagSlice';

export const useSzamlazzHuPanel = () => {
  const currentCompany = useAppSelector(currentCompanySelector);
  const dispatch = useAppDispatch();

  const onSubmit = (event) => {
    event.preventDefault();
    dispatch(toggleModal());
  };

  return {
    token: currentCompany?.szamlazzApiToken,
    onSubmit,
  };
};
